import {Configuration} from 'modules/auth/src/Configuration';
import {State} from './State';
import AuthModel from './Model';

export class AuthAppService {
    private readonly _configuration: Configuration;

    constructor() {
        this._configuration = new Configuration();
    }

    get state(): State {
        return this.configuration.getState();
    }

    get authModel(): AuthModel {
        return this.configuration.getAuthModel();
    }

    get configuration(): Configuration {
        return this._configuration;
    }

    makeAuthLinkByService(service: string): string {
        const params = {
            service: service,
            ...this.configuration.requestParams,
        }

        return '/login' + '?' + new URLSearchParams(params).toString();
    }
}
